import { atom } from 'jotai';

/**
 * Text the user has highlighted in a Scribe note/document editor, captured by
 * the selection bubble menu (see `useSelectionCapture`). While set, the
 * floating Ask Heidi bar shows a dismissible "Selected text" badge and any
 * message sent from the bar is scoped to this text (see
 * `composeSelectedTextQuestionPrompt`).
 */
export interface SelectedNoteText {
  text: string;
  /** Source range in the capturing editor, used to paint the pinned highlight. */
  from?: number;
  to?: number;
  /**
   * Identifies which `useSelectionCapture` instance owns the range, so only
   * the originating editor paints the pinned-context highlight.
   */
  captureId?: number;
}

export const selectedNoteTextAtom = atom<SelectedNoteText | null>(null);

/** Write-only convenience atom to drop the captured selection. */
export const clearSelectedNoteTextAtom = atom(null, (_get, set) => {
  set(selectedNoteTextAtom, null);
});

/**
 * One-shot trigger: increment to activate and focus the floating Ask Heidi
 * bar (used by the selection menu's "Ask anything" action). Mirrors the
 * `chatInputFocusTriggerAtom` pattern.
 */
export const floatingBarFocusTriggerAtom = atom<number>(0);
